import { initializeClipperFromBinary, unionPolygons } from "@nova/calculate-clipper"
import { defineTask } from "@nova/webworker-pool"

export const mergeIntersectingPolygons = defineTask({
    name: "mergeIntersectingPolygons",
    wasm: ["clipper"],
    run: async (
        { polygons, precision }: { polygons: [number, number][][]; precision?: number },
        { wasm }
    ) => {
        await initializeClipperFromBinary(wasm.clipper)
        return { data: unionPolygons(polygons, precision) }
    },
})
